var mentions_default = {
  "mentionPalette": "vcEfz",
  "mention": "DPFcq",
  "mentionViewer": "lJbQO",
  "mentionSuggestionsEntry": "Obmvw",
  "mentionSuggestionsEntryFocused": "TxMtX",
  "mentionSuggestionsEntryText": "OOrPA",
  "mentionSuggestionsEntryAvatar": "jd-je",
  "mentionSuggestions": "XtEvQ",
  "cursorDefault": "RRYnJ",
  "cursorPointer": "reLkv"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
